// MissaoBanner - aparece no topo do chat quando a criança veio de uma "Missão
// de Conversa" do Modo Atividades. Mostra o objetivo e o botão de cumprir.
import React, { useContext, useState, useEffect } from 'react';
import { CoreContext } from 'context/CoreContext';
import {
  carregarPerfilGamer,
  marcarMissaoFeita,
  ganharFigurinha,
} from 'services/atividades';

export default function MissaoBanner({ personagem, modo }) {
  const { currentProfile, user } = useContext(CoreContext);
  const [missao, setMissao] = useState(null);
  const [feita, setFeita] = useState(false);

  useEffect(() => {
    try {
      const m = JSON.parse(localStorage.getItem('jk_missao_ativa') || 'null');
      if (m && m.personagem === personagem && m.modo === modo) setMissao(m);
    } catch (e) {
      /* sem missão ativa */
    }
  }, [personagem, modo]);

  if (!missao) return null;

  const cumprir = async () => {
    const dono = currentProfile?.id || user?.id;
    let estado = await carregarPerfilGamer(currentProfile?.id, dono);
    estado = marcarMissaoFeita(currentProfile?.id, dono, estado, missao.id, missao.moedas);
    ganharFigurinha(currentProfile?.id, dono, estado, 'lulu_livro');
    localStorage.removeItem('jk_missao_ativa');
    setFeita(true);
  };

  const base = {
    maxWidth: 620,
    margin: '10px auto',
    padding: '12px 18px',
    borderRadius: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    boxShadow: 'var(--elev-1)',
    fontWeight: 600,
  };

  if (feita) {
    return (
      <div style={{ ...base, background: '#e8f7e8', border: '2px solid #5cb85c', color: '#2e7d32', justifyContent: 'center' }}>
        🎉 Missão cumprida! Você ganhou moedas e uma figurinha nova!
      </div>
    );
  }

  return (
    <div style={{ ...base, background: '#fff8e1', border: `2px solid ${missao.cor || '#ffb300'}`, color: 'var(--jk-text)' }}>
      <span style={{ flex: 1 }}>🎯 Missão: {missao.titulo}</span>
      <button
        onClick={cumprir}
        style={{
          border: 'none', borderRadius: 50, padding: '8px 16px', fontWeight: 'bold',
          background: '#5cb85c', color: 'white', cursor: 'pointer', whiteSpace: 'nowrap',
        }}
      >
        ✅ Cumpri!
      </button>
    </div>
  );
}
